import { fileUrl } from "@/lib/upload";

const ytId = (url) => {
  const m = url?.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{6,})/);
  return m ? m[1] : null;
};
const vimeoId = (url) => url?.match(/vimeo\.com\/(\d+)/)?.[1];

function VideoPlayer({ yt, vm, src }) {
  if (yt) return <iframe title="video" src={`https://www.youtube.com/embed/${yt}?rel=0&modestbranding=1`} className="w-full h-full" allow="autoplay; encrypted-media" allowFullScreen />;
  if (vm) return <iframe title="video" src={`https://player.vimeo.com/video/${vm}`} className="w-full h-full" allow="autoplay; fullscreen" allowFullScreen />;
  return <video src={src} className="w-full h-full" controls autoPlay muted loop playsInline data-testid="contest-video" />;
}

const posterFallback = (e) => {
  e.currentTarget.replaceWith(Object.assign(document.createElement("span"), { textContent: "Apri locandina (PDF)", className: "p-6 text-slate-700 font-semibold" }));
};

export default function ContestMedia({ contest }) {
  const yt = ytId(contest.video_url);
  const vm = vimeoId(contest.video_url);
  const videoFile = fileUrl(contest.video_file_id);
  const poster = fileUrl(contest.poster_file_id);
  const hasVideo = Boolean(yt || vm || videoFile || contest.video_url);
  if (!hasVideo && !poster) return null;
  return (
    <div className="grid sm:grid-cols-5 gap-4 mb-6" data-testid="contest-media">
      {hasVideo && (
        <div className={`${poster ? "sm:col-span-3" : "sm:col-span-5"} rounded-2xl overflow-hidden bg-black/40 shadow-xl aspect-video`}>
          <VideoPlayer yt={yt} vm={vm} src={videoFile || contest.video_url} />
        </div>
      )}
      {poster && (
        <a href={poster} target="_blank" rel="noreferrer" className="sm:col-span-2 rounded-2xl overflow-hidden bg-white shadow-xl grid place-items-center min-h-40" data-testid="contest-poster">
          <img src={poster} alt="Locandina" className="w-full h-full object-cover" onError={posterFallback} />
        </a>
      )}
    </div>
  );
}
